import script from "./MooringMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./MooringMap.vue?vue&type=script&lang=ts&setup=true"

import "./MooringMap.vue?vue&type=style&index=0&id=161b0b11&lang=css"

const __exports__ = script;

export default __exports__